<script>
import BarList from '../components/bar-list'
import NatfinForm from './natfin-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';
import { apiORDS, apiORDSdelete, urlORDS } from '../shared/api-functions'

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            activeTab: 0,
            natfinReceitas: [],
            natfinDespesas: [],
            codnatfin: '',
            codNatfinPai: '',
            codnatfinDestino: '',
            natfinItem: '',
            showModalDeleteNatFin: false,
            natfinDestErrorMsg: '',
            natfinDestError: ''
        }
    },

    computed: {
        // natfinList: function () {
        //     return this.$store.getters.getNatfinList
        // },
        tabs() {
            let tabs = []

            tabs = [
                { title: 'Receitas', icon: 'fa-archive' },
                { title: 'Despesas', icon: 'fa-cubes' }
            ]

            return tabs
        },
        tabReceitas() {
            return this.activeTab == 0
        },
        tabDespesas() {
            return this.activeTab == 1
        }
    },

    filters: {
        getText: function (value, metadata) {
            return getText(value, metadata)
        },

    },

    methods: {
        handleEdit (natfin) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codnatfin = natfin.codnatfin
            this.showForm = true;
        },
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codnatfin = ''
            this.showForm = true;
        },
        handleModalDelete (natfin) {
            //MODAL confirmação
            if (natfin.haschildren) {
                this.$erpToastError('Não é permitida a exclusão de um item que possui subitens!')
                return
            }

            this.showModalDeleteNatFin = true
            this.natfinItem = natfin

        },
        handleDelete (natfin) {
            //BOTAO Excluir
            if (natfin.haschildren) {
                this.$erpToastError('Não é permitida a exclusão de um item que possui subitens!')
                return
            }

            if (this.natfinDestError) {
                this.$erpToastError('Por favor, corrija os campos com alerta em vermelho')
                return
            }

            this.apiDelete(natfin)
        },
        handleSubgroup(natfin) {
            this.crud = SysVars.crudI
            this.codNatfinPai = natfin.codnatfin
            this.showForm = true
        },
        handleInputPai() {
            // remove a msg de erro
            this.natfinDestError = false

            let self = this
            let codnfdestino = this.codnatfinDestino ? this.codnatfinDestino : ''
            let url = this.$store.getters.urlOrds + 'cg/natfin/' + codnfdestino

            apiORDS(url, {}).then((result) => {
                if (result.items && result.items.length) {

                    let selectedNfDestino = result.items[0]

                    if (self.natfinItem.codnatfin == selectedNfDestino.codnatfin) {
                        this.natfinDestError = true
                        this.natfinDestErrorMsg = 'A natureza de destino deve ser diferente da natureza que está sendo excluida!'
                        return
                    }
                    
                    if (selectedNfDestino.haschildren) {                        
                        this.natfinDestErrorMsg = 'A natureza de destino não é permitida! Selecione uma natureza que não possua subitens vinculados!'
                        this.natfinDestError = true
                        return
                    }
                }
            })
        },
        async apiDelete (natfin) {
            //efetua a exclusao
            const codNfDestino = this.codnatfinDestino ? this.codnatfinDestino : ''
            var modulo = 'cg/natfin/' + natfin.codnatfin + '?destino=' + codNfDestino
            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },
        closeForm() {
            this.showForm = false
            this.showModalDeleteNatFin = false
            this.loadData()
        },
        search(value) {
            //efetua a pesquisa
            // this.filter = '{"$or":[{"codnatfin":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },
        async loadData() {
            // this.$store.dispatch('loadNatfin', { filter: this.filter } )
            // this.offset = ''
            let url = urlORDS(this.$store, 'cg/natfin/')

            const data = await apiORDS(url, {})
            
            // console.log(data)

            this.natfinReceitas = []
            this.natfinDespesas = []

            if (data.receitas) {
                this.natfinReceitas = data.receitas
            }
            if (data.despesas) {
                this.natfinDespesas = data.despesas
            }

            // console.log(this.natfinReceitas)
        },
        changeTab (idx) {
            // Mudança de pagina
            this.activeTab = idx
        },

        levelFont(level) {
            switch (level) {
                case 1:
                    return 'lbl-title font-weight-bold lvl-1'
            
                case 2:
                    return 'data-list font-weight-bold lvl-2'
                
                case 3:
                    return 'data-list lvl-3'
            }
        }
    },

    components: {
        BarList, NatfinForm
    },

    created () {
        this.showForm = false
        this.loadData()
        console.log(this.natfinItem)
    }
}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <!-- <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="false"
                single-entity="Natureza Financeira" 
                plural-entity="Naturezas Financeira"
                @search="search"
                @new="handleNew"
                @refresh="loadData">
            </bar-list> -->
            <br>

            <!-- Menu Tab Natureza Financeira -->
            <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>

            <!-- Tab Receitas -->
            <div class="default-container" v-if="tabReceitas">
                <div class="row d-flex justify-content-between">
                    <h2>Naturezas de Receita</h2>
                    <v-button label="Natureza de Receita" icon="fa-plus" :success="true" @click="handleNew" class="mr-2"></v-button>
                </div>
                <alert v-if="natfinReceitas.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="natfin in natfinReceitas" v-bind:key="natfin.codnatfin">
                    <div class="box">
                        <div class="row d-flex justify-content-between align-items-center">
                            <div class="col-md-8">
                                <div :class="'lvl-'+natfin.nivel">
                                    <span :class="levelFont(natfin.nivel)">
                                        {{ natfin.descricao }}
                                    </span>
                                    <span v-if="!natfin.haschildren && natfin.dre" class="data-list w-100 lvl-3">
                                        DRE: {{ natfin.dre }}
                                    </span>
                                    <span v-if="!natfin.haschildren && !natfin.dre" class="data-list w-100 lvl-3">
                                        Não considera no DRE
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-auto ml-auto" v-if="natfin.nivel != 1">
                                <v-button icon="fa-pencil" @click="handleEdit(natfin)"></v-button>
                                <v-button v-if="!natfin.haschildren" icon="fa-trash" @click="natfin.transferDelete ? handleModalDelete(natfin) : handleDelete(natfin)"></v-button>
                                <v-button icon="fa-plus" title="Adicionar sub-categoria" @click="handleSubgroup(natfin)" v-if="natfin.nivel != 3"></v-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tab Despesas -->
            <div class="default-container" v-if="tabDespesas">
                <div class="row d-flex justify-content-between">
                    <h2>Naturezas de Despesas</h2>
                    <v-button label="Natureza de Despesas" icon="fa-plus" :success="true" @click="handleNew" class="mr-2"></v-button>
                </div>

                <alert v-if="natfinDespesas.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="natfin in natfinDespesas" v-bind:key="natfin.codnatfin">
                    <div class="box">
                        <div class="row d-flex justify-content-between align-items-center">
                            <div class="col-md-8">
                                <div :class="'lvl-'+natfin.nivel">
                                    <span :class="levelFont(natfin.nivel)">
                                        {{ natfin.descricao }}
                                    </span>
                                    <span v-if="!natfin.haschildren && natfin.dre" class="data-list w-100 lvl-3">
                                        DRE: {{ natfin.dre }}
                                    </span>
                                    <span v-if="!natfin.haschildren && !natfin.dre" class="data-list w-100 lvl-3">
                                        Não considera no DRE
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-auto ml-auto" v-if="natfin.nivel != 1">
                                <v-button icon="fa-pencil" @click="handleEdit(natfin)"></v-button>
                                <v-button v-if="!natfin.haschildren" icon="fa-trash" @click="natfin.transferDelete ? handleModalDelete(natfin) : handleDelete(natfin)"></v-button>
                                <v-button icon="fa-plus" title="Adicionar sub-categoria" @click="handleSubgroup(natfin)" v-if="natfin.nivel != 3"></v-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <natfin-form 
            v-if="showForm" 
            :index="this.codnatfin" 
            :crud="this.crud" 
            :cod-natfin-pai="this.codNatfinPai" 
            :natfin-type="tabReceitas ? 'R' : 'D'"
            @closeform="closeForm">
        </natfin-form>
        
        <!-- Modal deletar -->
        <div class="nb-modal-scrollable" v-if="showModalDeleteNatFin">
            <div class="container nb-modal-scrollable-container nb-email-container">
                <div class="nb-modal-header">
                    <h5>Excluir Natureza Financeira</h5>
                    <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="nb-modal-scrollable-body">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="w-100 lbl">A natureza que está tentando excluir possui lançamentos associados.</span>
                            <span class="w-100 lbl">Selecione uma natureza para a qual serão transferidos os lançamentos da natureza atual.</span>
                        </div>
                    </div>
                    <hr>
                    <div class="row d-flex flex-column">
                        <form-field v-if="tabReceitas" v-model="codnatfinDestino" type="select2" col="4"
                        label="Natureza Financeira de Destino" :select2="{entity:'natfin/receitas', minlength: 0}" 
                        @input="handleInputPai"></form-field>

                        <form-field v-if="tabDespesas" v-model="codnatfinDestino" type="select2" col="4"
                        label="Natureza Financeira de Destino" :select2="{entity:'natfin/despesas', minlength: 0}" 
                        @input="handleInputPai"></form-field>

                        <span class="error ml-3 mb-3" v-if="natfinDestError">{{ natfinDestErrorMsg }}</span>
                    </div>
                    <div class="nb-modal-scrollable-footer">
                        <v-button ref="btnConfirm" label="Deletar" title="" :nb-btdef="true"  @click="handleDelete(natfinItem)"></v-button>
                        <v-button ref="btnClose" label="Cancelar" title="" @click="closeForm"></v-button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
    h2 {
        font-size: 2rem;
        color: #4993d2;
        margin-left: 1rem;
    }

    .default-container {
        padding: 2rem;
        border: none !important;
    }

    .lvl-1 {
        margin-left: .5rem;
    }

    .lvl-2 {
        margin-left: 1.5rem;
    }

    .lvl-3 {
        margin-left: 2.5rem;
    }

    #badge {
        content: '';
        font-size: 5px;
        padding: 1px 4px; 
        border-radius: 100%;
        margin-right: .5rem;
    }
</style>



// WEBPACK FOOTER //
// src/forms/natfin-list.vue